import React from "react";
import Banner from "../../Components/Banner";
import Featured from "../../Components/Featured";
import Product from "../../Components/Product";
import Discount from "../../Components/Discount";
import Blog from "../../Components/Blog";
import Testomonials from "../../Components/Testomonials";
import Brands from "../../Components/Brands";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
const Home = (user) => {
  return (
    <div>
      <Header user={user}/>
      <Banner />
      <Featured />
      <Product />
      <Discount />
      <Blog />
      <Testomonials />
      <Brands />
      <Footer/>
      
    </div>
  );
};

export default Home;
